'use strict';
const angular = require('angular');

/*@ngInject*/
export function HistoryService($resource) {
  return $resource('/api/histories/:id', {
    name: '@_id'
  },{
    getByEntity: {
      method: 'GET',
      url: "/api/histories/entity/:id",
      isArray: true
    },
    getInsight: {
      method: 'GET',
      url: "/api/histories/insight/:year/:month/:id",
      isArray: true
    }
  });
}

export default angular.module('conduu.ap.services.HistoryService', [])
  .factory('HistoryService', HistoryService)
  .name;



// WEBPACK FOOTER //
// ./client/~ap/services/history/history.service.js